import React from 'react';
import EomExportFilterTypeEnum from '../../../Enums/EomExportFilterTypeEnum';

export default class EOMExportItem {
  constructor(item) {
    if (item === undefined) {
      this.Offices = [];
      this.ExportType = 1; // EOM Export
      this.FilterType = EomExportFilterTypeEnum.All;
    } else {
      this.Offices = item.offices;
      this.ExportType = 1; // EOM Export
      this.FilterType = EomExportFilterTypeEnum.All;
    }
    this.Notes = (
      <span>
        Please select the offices for this end of month payment export, then click on the start button.
        <br />
        <br />
        The payment export will start within an hour.
      </span>
    );
  }
}
